/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// React Router
import { Link } from 'react-router-dom';

const Button = ({ data }) => {
    return (
        <div className="button w-full mb-4">
            {data.linkType === 'route' ?
                <Link to={data.link}>
                    <button href={data.link} className="text-gray-300 font-semibold w-full py-3 px-3 bg-primary rounded-md text-sm">
                        {data.name}
                    </button>
                </Link>
            :
                <a href={data.link}>
                    <button href={data.link} className="text-gray-300 font-semibold w-full py-3 px-3 bg-primary rounded-md text-sm">
                        {data.name}
                    </button>
                </a>
            }
        </div>
    )
}

export default Button